import { render, staticRenderFns } from "./AddCashCollectionDialog.vue?vue&type=template&id=def154f4&scoped=true&"
import script from "./AddCashCollectionDialog.vue?vue&type=script&lang=js&"
export * from "./AddCashCollectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def154f4",
  null
  
)

export default component.exports